import React from 'react';
import { useHistory } from 'react-router-dom';
import baseStyles from './back_button.module.css';
import { Theme, useStyles } from 'ui/base/theme';


type BackButtonStyles = {
  back: string;
};

const themedStyles: Record<Theme, BackButtonStyles> = {
  [Theme.DAYLIGHT]: {
    back: baseStyles.daylightBack,
  },
  [Theme.MIDNIGHT]: {
    back: baseStyles.midnightBack,
  },
};

type BackButtonProps = {
  onClick?(): void;
};

export const BackButton = ({ onClick }: BackButtonProps): React.ReactElement => {
  const styles = useStyles(themedStyles);
  const history = useHistory();
  return <div className={styles.back} onClick={onClick ? onClick : history.goBack}/>;
};
